import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { Terminal, TerminalState } from "./terminal";

export class WinConditionTerminal extends Terminal {
	static key = "WinConditionTerminal";
	constructor(xy: XY) {
		super(xy);
	}

	runTerminalAction(): void {
		this.board!.gameFlags.gameWon = true;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), state: this.state };
	}

	static deserialize(data: any): WinConditionTerminal {
		const t = new WinConditionTerminal(deserializeXY(data.xy));
		t.visualId = data.visualId;
		t.state = data.state ?? TerminalState.ACTIVE;
		return t;
	}
}
